import Vue from "vue";
import Guid from "~/helpers/guid";
import ProcessFlowStep from "~/models/processFlows/processFlowStep";
import ProcessFlowStepJumpTo from "~/models/processFlows/processFlowStepJumpTo";
import ProcessFlowStepElementConditionalRuleSet from "~/models/processFlows/processFlowStepElementConditionalRuleSet";
import {IJumpTo} from '~/interfaces/modeling/jumpToInterfaces'

export default class ProcessFlowStepJumpToFactory {
  static create(parent: ProcessFlowStep | ProcessFlowStepElementConditionalRuleSet): ProcessFlowStepJumpTo {
    return ProcessFlowStepJumpToFactory.createFor(parent,
      'jump_to');
  }

  static findOrCreate(parent: ProcessFlowStep | ProcessFlowStepElementConditionalRuleSet, json: Partial<IJumpTo>): ProcessFlowStepJumpTo {
    json = json || {}
    return ProcessFlowStepJumpToFactory.findOrCreateFor(parent,
      'jump_to', json);
  }

  private static createFor(parent: ProcessFlowStep | ProcessFlowStepElementConditionalRuleSet, fieldName: string) {
    const processFlowStepJumpTo: ProcessFlowStepJumpTo = new ProcessFlowStepJumpTo();

    processFlowStepJumpTo.defineProperty('client_id', Guid.create());
    processFlowStepJumpTo.defineProperty('to_client_id', '');

    processFlowStepJumpTo.parent = parent;
    Vue.set(parent, fieldName, processFlowStepJumpTo);

    return processFlowStepJumpTo;
  }

  private static findOrCreateFor(parent: ProcessFlowStep | ProcessFlowStepElementConditionalRuleSet, fieldName: string, json: Partial<IJumpTo>) {
    let processFlowStepJumpTo: ProcessFlowStepJumpTo = ProcessFlowStepJumpTo.repo.find(json.client_id)
    if (!processFlowStepJumpTo) {
      processFlowStepJumpTo = new ProcessFlowStepJumpTo()

      processFlowStepJumpTo.defineClientId(json.client_id)
      processFlowStepJumpTo.defineProperty('to_client_id', json.to_client_id || '')

      processFlowStepJumpTo.parent = parent
      Vue.set(parent, fieldName, processFlowStepJumpTo)
    }

    return processFlowStepJumpTo
  }
}